import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const state = {

  activeSidebar: (localStorage.getItem('activeSidebar')=='true')

};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/home/index.js